module.exports = __webpack_public_path__ + "img/d-bg.481ae32f.png";